/* Config file */
export const config = {
    showError: 'showError',
    token: {
        validateMinutesInterval: 'validateMinutesInterval',
        renewMinutes: 'renewMinutes'
    },
    logInfoDevice: 'logInfoDevice',
    encryptStorage: 'encryptStorage',
    encryptKey: 'encryptKey',
    encryptKeyPassword: 'encryptKeyPassword',
    entraId: {
        rootBase: 'rootBase',
        clientId: 'clientId',
        tenantId: 'tenantId',
        authority: 'authority',
        redirectUri: 'redirectUri',
        redirectLogout: 'redirectLogout'
    },
    intervalWaitSSO: 'intervalWaitSSO',
    onlineHelp: {
        frenchLink: 'frenchLink',
        englishLink: 'englishLink',
    },
    companyTitle: 'companyTitle'
}
/* Config file */

// This will be all the encrypted parameters
export const appgoParams = 'appgo.params';

// This will be all the non encrypted parameters
export const knkParams = 'knk.params';


export const userCode = 'userCode';

export const userName = 'userName';

export const employeeId = 'employeeId';

export const menu = 'menu';

export const abcUsage = 'abcUsage';

export const linkProjectPActivity = 'linkProjectPActivity';

export const language = 'language';

export const googleApiKey = 'googleApiKey';

export const token = 'token';

export const sessionGuid = 'sessionGuid';

export const expenseAccountActivities = 'expenseAccountActivities';

export const expandedTimesheet = 'expandedTimesheet';

export const startDayTimesheet = 'startDayTimesheet';

export const useTimeTimesheet = 'useTimeTimesheet';

export const useTimeTimesheetRequired = 'useTimeTimesheetRequired';

export const acceptedTermsUse = 'acceptedTermsUse';

export const termsUse = 'termsUse';

export const legalInfo = 'legalInfo';

export const showDateStatementTerms = 'showDateStatementTerms';

export const showDateStatementLegalInfo = 'showDateStatementLegalInfo';

export const scheduleReturnDate = 'scheduleReturnDate';

export const filterRequest = 'filterRequest';

export const isPasswordComplex = 'isPasswordComplex';

export const minLengthPassword = 'minLengthPassword';

export const clientHashKey = 'clientHashKey';

export const useGeolocation = 'useGeolocation';

export const useGeolocationZone = 'useGeolocationZone';

export const creditCardSupport = 'creditCardSupport';

export const companies = 'companies';

export const punchTime = 'punchTime';

export const colorCalendar = 'colorCalendar';

export const useWorkInstructions = 'useWorkInstructions';

export const displayMedicalData = 'displayMedicalData';

export const connectionString = 'connectionString';

export const displayDistributionSlip = 'displayDistributionSlip';

export const displayPreferenceCommunication = 'displayPreferenceCommunication';

export const isCCQ = 'isCCQ';

export const partialRequestHoursUsed = 'partialRequestHoursUsed';

export const taxationProvince = 'taxationProvince';

export const filterExpenseAccount = 'filterExpenseAccount';

export const isMandatoryPhoneCellPerso = 'isMandatoryPhoneCellPerso';

export const isMandatoryEmailPerso = 'isMandatoryEmailPerso';

export const isDisplayPayAdvanceVacation = 'isDisplayPayAdvanceVacation';

export const isMandatorySMSPerso = 'isMandatorySMSPerso';

export const communicationPreference = 'communicationPreference';

export const isUsePartialRequest = 'isUsePartialRequest';

export const isSSO = 'isSSO';

export const isAuthSSO = 'isAuthSSO';

export const isDisplayPayablesHours = 'isDisplayPayablesHours';

export const isDisplayFlagFullTime = 'isDisplayFlagFullTime';

export const isUseMaterialResourceTimesheet = 'isUseMaterialResourceTimesheet';

export const showSubscribe = 'showSubscribe';

export const notificationPublicKey = 'notificationPublicKey';

export const notificationPrivateKey = 'notificationPrivateKey';

export const isNotificationActivate = 'isNotificationActivate';

export const isProfileConsultationMode = 'isProfileConsultationMode';

export const listPrefixConnection = 'listPrefixConnection';

export const isDisplayBankOthers = 'isDisplayBankOthers';

export const isDisplayBankVacation = 'isDisplayBankVacation';

export const useServiceProvider = 'useServiceProvider';

export const useGeolocationMandatory = 'useGeolocationMandatory';